// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Light polish of the access forms (login, password reset/request, account creation) that keeps
 * their original layout: outlined fields like the other forms, more breathing room
 * and clearer buttons. Use it with @include auth-polish.form; at the END of the form
 * stylesheet, so it wins over the older rules. */
/* Page around the forms: slightly narrower column and a more compact logo */
ion-checkbox {
  margin-left: 0;
}

ion-button {
  width: 100%;
}

ion-icon {
  height: 15px;
  font-size: 16px;
  vertical-align: middle;
}

.item-remember-me {
  margin-top: 9px;
}

.item-auto-access {
  margin-bottom: 9px;
}

.checkbox-in-list,
.checkbox-label {
  margin-top: 0;
  margin-bottom: 0;
}

.item-checkbox {
  --ripple-color: transparent;
  --background-hover: var(--background);
  --min-height: 35px;
}

.button-login {
  --box-shadow: none;
  --border-radius: 10px;
}

.button-account {
  border: 1px solid var(--ion-color-primary);
  border-radius: 10px;
}

.button-google {
  --box-shadow: none;
  --background: white;
  color: var(--ion-color-medium);
  border-radius: 10px;
  border: 2px solid rgba(var(--ion-color-medium-rgb), 0.25);
  white-space: nowrap;
}

.label-forgot-password {
  cursor: pointer;
  font-size: 14px;
}
.label-forgot-password:hover {
  text-decoration: underline;
}

.container-access-login {
  padding-bottom: var(--ion-safe-area-bottom);
}

/* Light polish keeping the original look (kept last so it wins over the rules above) */
/* Fields: outlined and rounded like the other forms, primary ring when focused */
ion-input[fill=outline],
ion-select[fill=outline] {
  --border-radius: 10px;
  --border-color: rgba(var(--ion-color-medium-rgb), 0.4);
  --highlight-color-focused: var(--ion-color-primary);
  --background: var(--ion-background-color, #fff);
  min-height: 56px;
  margin-bottom: 14px;
}

/* Title / description of the forms */
.titleLbl {
  font-size: 20px;
  font-weight: 700;
  text-align: left;
}

.descriptionlbl {
  font-size: 14px;
  line-height: 1.5;
  text-align: left;
  color: var(--ion-color-medium-shade);
}

/* "Forgot password?": on the right, under the password */
ion-item:has(.label-forgot-password) {
  --background: transparent;
  --padding-start: 0;
  --inner-padding-end: 0;
  margin-top: -6px;
  text-align: right;
}

.label-forgot-password {
  font-size: 14px;
  font-weight: 600;
}

/* Primary action */
.button-login {
  height: 50px;
  margin-top: 12px;
  --border-radius: 10px;
  --box-shadow: none;
  font-weight: 600;
  letter-spacing: 0.5px;
}

/* Secondary actions (create account, go back): outlined, same size */
.button-account,
.button-go-back {
  height: 50px;
  margin-top: 10px;
  border: 1px solid rgba(var(--ion-color-primary-rgb), 0.5) !important;
  border-radius: 10px !important;
  --border-radius: 10px;
  font-weight: 600;
  letter-spacing: 0.5px;
  transition: background-color 0.15s ease;
}
.button-account:hover,
.button-go-back:hover {
  background-color: rgba(var(--ion-color-primary-rgb), 0.06) !important;
}`, "",{"version":3,"sources":["webpack://./src/theme/_auth-polish.scss","webpack://./src/components/form-components/form-login/form-login.component.scss"],"names":[],"mappings":"AAAA;;;iDAAA;AAyEA,4EAAA;ACvEA;EACE,cAAA;AAIF;;AADA;EACE,WAAA;AAIF;;AADA;EACE,YAAA;EACA,eAAA;EACA,sBAAA;AAIF;;AADA;EACE,eAAA;AAIF;;AADA;EACE,kBAAA;AAIF;;AADA;;EAEE,aAAA;EACA,gBAAA;AAIF;;AADA;EACE,2BAAA;EACA,qCAAA;EACA,kBAAA;AAIF;;AADA;EACE,kBAAA;EACA,qBAAA;AAIF;;AADA;EACE,0CAAA;EACA,mBAAA;AAIF;;AADA;EACE,kBAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,yDAAA;EACA,mBAAA;AAIF;;AADA;EACE,eAAA;EACA,eAAA;AAIF;AAFE;EACE,0BAAA;AAIJ;;AAAA;EACE,2CAAA;AAGF;;AAAA,uFAAA;AD9DE,iFAAA;AACA;;EAEE,qBAAA;EACA,sDAAA;EACA,mDAAA;EACA,+CAAA;EACA,gBAAA;EACA,mBAAA;ACkEJ;;AD/DE,qCAAA;AACA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;ACkEJ;;AD/DE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oCAAA;ACkEJ;;AD/DE,yDAAA;AACA;EACE,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;ACkEJ;;AD/DE;EACE,eAAA;EACA,gBAAA;ACkEJ;;AD/DE,mBAAA;AACA;EACE,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;ACkEJ;;AD/DE,qEAAA;AACA;;EAEE,YAAA;EACA,gBAAA;EACA,oEAAA;EACA,8BAAA;EACA,qBAAA;EACA,gBAAA;EACA,qBAAA;EACA,uCAAA;ACkEJ;ADhEI;;EACE,qEAAA;ACmEN","sourcesContent":["/* Light polish of the access forms (login, password reset/request, account creation) that keeps\n * their original layout: outlined fields like the other forms, more breathing room\n * and clearer buttons. Use it with @include auth-polish.form; at the END of the form\n * stylesheet, so it wins over the older rules. */\n\n@mixin form {\n  /* Fields: outlined and rounded like the other forms, primary ring when focused */\n  ion-input[fill=\"outline\"],\n  ion-select[fill=\"outline\"] {\n    --border-radius: 10px;\n    --border-color: rgba(var(--ion-color-medium-rgb), 0.4);\n    --highlight-color-focused: var(--ion-color-primary);\n    --background: var(--ion-background-color, #fff);\n    min-height: 56px;\n    margin-bottom: 14px;\n  }\n\n  /* Title / description of the forms */\n  .titleLbl {\n    font-size: 20px;\n    font-weight: 700;\n    text-align: left;\n  }\n\n  .descriptionlbl {\n    font-size: 14px;\n    line-height: 1.5;\n    text-align: left;\n    color: var(--ion-color-medium-shade);\n  }\n\n  /* \"Forgot password?\": on the right, under the password */\n  ion-item:has(.label-forgot-password) {\n    --background: transparent;\n    --padding-start: 0;\n    --inner-padding-end: 0;\n    margin-top: -6px;\n    text-align: right;\n  }\n\n  .label-forgot-password {\n    font-size: 14px;\n    font-weight: 600;\n  }\n\n  /* Primary action */\n  .button-login {\n    height: 50px;\n    margin-top: 12px;\n    --border-radius: 10px;\n    --box-shadow: none;\n    font-weight: 600;\n    letter-spacing: 0.5px;\n  }\n\n  /* Secondary actions (create account, go back): outlined, same size */\n  .button-account,\n  .button-go-back {\n    height: 50px;\n    margin-top: 10px;\n    border: 1px solid rgba(var(--ion-color-primary-rgb), 0.5) !important;\n    border-radius: 10px !important;\n    --border-radius: 10px;\n    font-weight: 600;\n    letter-spacing: 0.5px;\n    transition: background-color 0.15s ease;\n\n    &:hover {\n      background-color: rgba(var(--ion-color-primary-rgb), 0.06) !important;\n    }\n  }\n}\n\n/* Page around the forms: slightly narrower column and a more compact logo */\n@mixin page {\n  .content-login {\n    width: min(100%, 520px);\n  }\n\n  .container-logo-login img {\n    max-height: 180px;\n    margin-block-end: 32px;\n  }\n}\n","@use \"../../../theme/auth-polish\";\n\nion-checkbox {\n  margin-left: 0;\n}\n\nion-button {\n  width: 100%;\n}\n\nion-icon {\n  height: 15px;\n  font-size: 16px;\n  vertical-align: middle;\n}\n\n.item-remember-me {\n  margin-top: 9px;\n}\n\n.item-auto-access {\n  margin-bottom: 9px;\n}\n\n.checkbox-in-list,\n.checkbox-label {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.item-checkbox {\n  --ripple-color: transparent;\n  --background-hover: var(--background);\n  --min-height: 35px;\n}\n\n.button-login {\n  --box-shadow: none;\n  --border-radius: 10px;\n}\n\n.button-account {\n  border: 1px solid var(--ion-color-primary);\n  border-radius: 10px;\n}\n\n.button-google {\n  --box-shadow: none;\n  --background: white;\n  color: var(--ion-color-medium);\n  border-radius: 10px;\n  border: 2px solid rgba(var(--ion-color-medium-rgb), 0.25);\n  white-space: nowrap;\n}\n\n.label-forgot-password {\n  cursor: pointer;\n  font-size: 14px;\n\n  &:hover {\n    text-decoration: underline;\n  }\n}\n\n.container-access-login {\n  padding-bottom: var(--ion-safe-area-bottom);\n}\n\n/* Light polish keeping the original look (kept last so it wins over the rules above) */\n@include auth-polish.form;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
